export const isVendorChargePaid = (accessorialId = '', vendorPayables = []) => {
  if (vendorPayables?.length) {
    const vendorCharge = vendorPayables.find(
      (charge) => charge?.accessorial_request_id === accessorialId,
    );
    if (vendorCharge) {
      return vendorCharge?.payment_status === 'paid';
    }
  }
  return false;
};
